import { render, staticRenderFns } from "./PackageExplorer.vue?vue&type=template&id=1b2358bd&scoped=true&mlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./PackageExplorer.vue?vue&type=script&lang=js&"
export * from "./PackageExplorer.vue?vue&type=script&lang=js&"
import style0 from "./PackageExplorer.vue?vue&type=style&index=0&id=1b2358bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2358bd",
  null
  
)

component.options.__file = "PackageExplorer.vue"
export default component.exports